function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Space, Alert } from 'antd';
import { SendFill } from 'react-bootstrap-icons';
import axios from 'axios';
import Common from '../includes/Common';
import { Spinner } from 'react-bootstrap';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var ContactForm = function ContactForm() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mailSending = _useState2[0],
      setMailSending = _useState2[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var onMailSubmit = function onMailSubmit(values) {
    setMailSending(true);
    var formData = new FormData();
    formData.append('name', values.name);
    formData.append('email', values.email);
    formData.append('phone', values.phone);
    formData.append('content', values.content);
    axios.post(Common.baseApiUrl + 'sendemail', formData).then(function (response) {
      setMailSending(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setMailSending(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      name: '',
      email: '',
      phone: '',
      content: ''
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h3", {
      children: "Contactez-nous "
    }), /*#__PURE__*/_jsx("h5", {
      children: "Demandez une assistance, des suggestions ... "
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "large",
      onFinish: onMailSubmit,
      form: form,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), successMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "name",
        rules: [{
          required: true,
          message: 'Veuillez enter votre nom'
        }],
        label: "Votre nom",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email",
        label: "E-mail",
        rules: [{
          type: 'email'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "phone",
        rules: [{
          required: true,
          message: 'Veuillez entrer votre numéro'
        }],
        label: "T\xE9l\xE9phone",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "content",
        rules: [{
          required: true,
          message: 'Veuillez enter votre suggestion'
        }],
        lable: "Suggestions",
        children: /*#__PURE__*/_jsx(TextArea, {
          placeholder: "Suggestion",
          autoSize: {
            minRows: 2,
            maxRows: 6
          }
        })
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "submit",
          children: /*#__PURE__*/_jsx(Button, {
            type: "default",
            htmlType: "submit",
            children: /*#__PURE__*/_jsx(SendFill, {})
          })
        }), mailSending ? /*#__PURE__*/_jsx(Spinner, {
          animation: "grow"
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      })]
    })]
  });
};

export default ContactForm;